export default "__VITE_ASSET__Cdft5_xU__"